var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockNew = function SvgClockNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0875C4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1.667C5.41 1.667 1.667 5.408 1.667 10S5.409 18.333 10 18.333s8.334-3.741 8.334-8.333S14.592 1.667 10 1.667m0 15A6.676 6.676 0 0 1 3.334 10 6.676 6.676 0 0 1 10 3.333 6.676 6.676 0 0 1 16.667 10 6.676 6.676 0 0 1 10 16.666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.834 5H9.167v5c0 .458.375.833.833.833h3.334V9.167h-2.5z"
  }))));
};
export { SvgClockNew as Icon };
export default __webpack_public_path__ + "static/media/c1baa0538e0afca3e22286e64dc9b08c.svg";